import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/modules/material.module';
import { ConfirmDialogDirective } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.directive';
import { DialogContainerComponent } from 'src/app/shared/dialogs/dialog-container/dialog-container.component';
import { TextOverflowLabelComponent } from 'src/app/shared/main-table-module/main-table-module-specific-template/table-module-templates/cells/text-overflow-label/text-overflow-label.component';
import { AppendDomainPipe } from 'src/app/shared/pipes/append-domain-name.pipe';
import { UIElementsModule } from 'src/app/shared/ui-elements/ui-elements.module';
import { CartContentComponent } from '../../components/cart-content/cart-content.component';
import { CartDraftPickerModalComponent } from '../cart-draft-picker-modal/cart-draft-picker-modal.component';
import { CartMergeStrategyModalComponent } from '../cart-merge-strategy-modal/cart-merge-strategy-modal.component';
import { CartModalComponent } from './cart-modal.component';

@NgModule({
  declarations: [
    CartContentComponent,
    CartDraftPickerModalComponent,
    CartMergeStrategyModalComponent,
    CartModalComponent,
  ],
  exports: [CartContentComponent, CartModalComponent],
  imports: [
    CommonModule,
    AppendDomainPipe,
    ConfirmDialogDirective,
    DialogContainerComponent,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    TextOverflowLabelComponent,
    TranslateModule,
    UIElementsModule,
  ],
})
export class CartModalModule {}
